import { UPDATE_RETAILER_SHOPIFY_SHOP } from '../actionTypes';

const initialState = {
  retailer_info: {},
  currentRetailerUser: {}
};

const retailerUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_RETAILER_INFO':
      return {
        ...state,
        retailer_info: action.data?.current_retailer || state.retailer_info || {}
      };
    case 'GET_CURRENT_RETAILER_USER_INFO':
      return {
        ...state,
        currentRetailerUser: action.data.current_retailer_user
      };
    case UPDATE_RETAILER_SHOPIFY_SHOP:

      return {
        ...state,
        retailer_info: {
          ...state.retailer_info,
          shopify_shop: {
            ...state.retailer_info.shopify_shop,
            ...action.payload
          }
        }
      };
    default:
      return state;
  }
};

export default retailerUsersReducer;
